var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('base-button',_vm._b({attrs:{"right":"","x-small":"","icon":"$arrowRight","width":"645px"}},'base-button',_vm.$attrs,false),[_vm._v(" Se connecter ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }